import React from 'react';
import { motion } from 'framer-motion';

const ServicesHeader = () => {
  return (
    <motion.div 
      className="row mb-5"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.15
          }
        }
      }}
    >
      <div className="col-12 text-center">
        <motion.h2 
          className="display-5 fw-bold mb-4 service-title" 
          style={{ color: `var(--color-white)` }}
          variants={{
            hidden: { 
              opacity: 0, 
              y: 60, 
              scale: 0.95,
              filter: "blur(4px)"
            },
            visible: { 
              opacity: 1, 
              y: 0, 
              scale: 1,
              filter: "blur(0px)",
              transition: {
                type: "spring",
                damping: 15,
                stiffness: 100,
                duration: 0.8
              }
            }
          }}
        >
          Our Core Services
        </motion.h2>
        <motion.p 
          className="subtitle" 
          style={{ 
            color: `var(--color-white)`, 
            maxWidth: '800px', 
            margin: '0 auto', 
            opacity: '0.9', 
            fontSize: '1.1rem' 
          }}
          variants={{
            hidden: { 
              opacity: 0, 
              y: 40, 
              scale: 0.97,
              filter: "blur(4px)"
            },
            visible: { 
              opacity: 0.9, 
              y: 0, 
              scale: 1,
              filter: "blur(0px)",
              transition: {
                type: "spring",
                damping: 15,
                stiffness: 100,
                duration: 0.8,
                delay: 0.2
              }
            }
          }}
        >
          Empowering your business with cutting-edge technology solutions and expert guidance
        </motion.p>
      </div>
    </motion.div>
  );
};

export default ServicesHeader;